
import { Component, Vue } from "vue-property-decorator";
import CandidateV3Custom, {
  CandidateV3Item
} from "@/lib/model/exambuilder/candidate-v3/candidate-v3";
import CandidateItem from "../components/candidateItem.vue";
import TableChars from "@/views/exam-v3/components/table-chars.vue";
import ExamList from "@/lib/model/exam/exam";
import Auth from "@/lib/common/auth";
import { ExamGetAllForm } from "@/lib/form/exam/ExamListForm";
import CandidateTable from "@/views/exam-v3/components/candidate-table.vue";
import { CandidateCount } from "@/lib/dash/dash-v3";
import CandidateSelect from "@/views/exam-v3/components/candidate-select.vue";
import AddCandidate from "@/views/exam-v3/components/add-candidate.vue";
import CandidateCreateForm from "@/lib/form/candidate/CandidateCreateForm";
import AddMoreCandidateModal from "@/views/exam-v3/components/add-candidates.vue";
import examLink from "@/views/exam-v3/components/exam-link.vue";
import AddOneCandidateModal from "@/views/exam-v3/components/add-candidate.vue";
import {
  CandidateMCreateParams,
  CandidateMCreateParseParams
} from "@/lib/model/exam/candidate";
import { ExamGetForm } from "@/lib/form/exam/ExamListForm";
import DeleteDialog from "@/views/exam-v3/components/delete-dialog.vue";
import CandidateListForm from "@/lib/form/candidate/CandidateListForm";
import track from "@/lib/common/track";
import vuexStore from "@/store/vuex-store";
import Template from "@/views/ai-builder/components/template.vue";

interface ExamItem {
  id: number;
  name: string;
  remark: string;
  isEnableAi: boolean;
  examTypeFlag: boolean;
  examId?: number;
}

@Component({
  components: {
    Template,
    AddOneCandidateModal,
    CandidateTable,
    CandidateItem,
    TableChars,
    CandidateSelect,
    AddCandidate,
    examLink,
    AddMoreCandidateModal,
    DeleteDialog
  }
})
export default class CandidateListV3 extends Vue {
  // 筛选相关
  examList: ExamItem[] = [];
  searchForm = new CandidateListForm().assign({
    companyId: Number(Auth.companyId),
    examType: "aibuilder",
    sortKey: "",
    sortDict: "",
    asCompany: 1
  });

  vuex = vuexStore;

  // 列表数据
  loadingList = true;
  data: CandidateV3Item[] = [];
  total = 0;

  // 获取全部面试
  async getExamAll() {
    const params = new ExamGetAllForm();
    params.companyId = Number(Auth.companyId);
    const res = await ExamList.examGetAll(params);
    res.list.forEach((examRes: any) => {
      this.examList.push({
        id: examRes.examId,
        name: examRes.name,
        remark: examRes.remark,
        isEnableAi: examRes.companySpecialConfig?.isEnableAi === 1,
        examTypeFlag: examRes.examType !== "test"
      });
    });
  }

  mounted() {
    this.getHeadData();
  }

  // 快速搜索
  handleQuickSearch({ type, row }: { type: string; row: CandidateV3Item }) {
    this.searchForm.page = 1;

    console;
    if (type === "repeatExam") {
      this.searchForm.examId = row.examId;
      this.searchForm.submitStatusList = [];
      this.searchForm.showNameOrPhone = row.phone;
      this.activeExamItem.examId = row.examId;
      this.activeExamItem.name = row.examName;
      this.getHeadData(row.examId);
      this.getCandidateList();
    }

    if (type === "repeatCompany") {
      this.searchForm.examId = 0;
      this.searchForm.submitStatusList = [];
      this.searchForm.showNameOrPhone = row.phone;
      this.activeExamItem.examId = 0;
      this.activeExamItem.name = "";
      this.getHeadData();
      this.getCandidateList();
    }
  }

  // 获取面试候选人列表
  async getCandidateList() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.loadingList = true;
    const res = await CandidateV3Custom.get(this.searchForm);
    this.data = res.list;
    this.total = res.count;
    this.loadingList = false;
  }

  // 面试详情展示字段
  echarsData: number[] = [];
  examAll = 0;
  examNotSignIn = 0;
  examSignIn = 0;
  examAnswering = 0;
  examFinishAll = 0;

  headerLoading = false;

  getHeadData(examId = 0) {
    this.headerLoading = true;
    this.echarsData = [0, 0, 0, 0];
    this.$nextTick(() => {
      const ref = this.$refs.TableChars as any;
      ref.updateOption();
    });
    CandidateCount.get({ examId }).then(res => {
      const {
        answering,
        signIn,
        notSignIn,
        finish: {
          all,
          aiRecommendStatusVeryRecommend,
          aiRecommendStatusRecommend,
          aiRecommendStatusNormal,
          aiRecommendStatusNotRecommend
        }
      } = res;
      this.echarsData = [
        aiRecommendStatusVeryRecommend,
        aiRecommendStatusRecommend,
        aiRecommendStatusNormal,
        aiRecommendStatusNotRecommend
      ];
      this.examFinishAll = all;
      this.examNotSignIn = notSignIn;
      this.examAnswering = answering;
      this.examSignIn = signIn;
      this.examAll = res.all;
      this.headerLoading = false;
      this.$nextTick(() => {
        const ref = this.$refs.TableChars as any;
        ref.updateOption();
      });
    });
  }
  activeExamItem: any = {
    examId: "",
    name: ""
  };
  examChange(examItem: any) {
    this.getHeadData(examItem.examId);
    this.searchForm.examId = examItem.examId;
    this.activeExamItem = examItem;
    this.searchForm.page = 1;
    this.getCandidateList();
    (this.$refs.tableRef as any).handleClearSelected();
  }

  examSubmitStatusChange(value: number) {
    if (value === -1) {
      this.searchForm.submitStatusList = [];
    } else {
      this.searchForm.submitStatusList = [value];
    }
    this.searchForm.page = 1;
    this.getCandidateList();
    this.getHeadData(this.searchForm.examId);
  }
  async created() {
    await Promise.all([this.getExamAll(), this.getCandidateList()]);
  }
  showDialog(dropdownItem: string, e: any) {
    const itemFunMap = {
      openInvitation: this.openInvitationDo,
      invitePeople: this.invitePeopleDo,
      bulkInvitation: this.bulkInvitationDo
    };
    itemFunMap[dropdownItem] && itemFunMap[dropdownItem](e);
  }
  showExamLink = false;
  scanLink = "";
  scanUrl = "";
  async openInvitationDo(e: any) {
    if (this.activeExamItem.canOpenJoin !== 1) {
      return;
    }
    const params = {
      examId: this.searchForm.examId,
      companyId: parseInt(Auth.companyId)
    };

    const wsaRes = await ExamList.wsaCode(params);
    if (wsaRes.code !== 0) return;

    this.showExamLink = true;
    this.scanLink = wsaRes.data.base64string
      ? `data:image/png;base64,${wsaRes.data.base64string}`
      : "";

    const urlRes = await ExamList.examUrl(params);

    if (urlRes.code !== 0) return;

    this.scanUrl = urlRes.data.url;
  }
  closeExamLink() {
    this.showExamLink = false;
    this.getCandidateList();
  }
  addCandidate = false;
  candidateCreateForm = new CandidateCreateForm();
  invitePeopleDo() {
    this.addCandidate = true;
  }
  isShowAddMore = false;
  candidateMCreateParseParams = new CandidateMCreateParseParams();
  candidateMCreateParams = new CandidateMCreateParams();
  examGetForm = new ExamGetForm();
  bulkInvitationDo() {
    this.isShowAddMore = true;
  }
  handleMoreClose() {
    this.isShowAddMore = false;
    this.getCandidateList();
  }
  moreDoClick(dropdownItem: string) {
    const itemFunMap = {
      assess: this.assessDo,
      export: this.exportDo
    };
    itemFunMap[dropdownItem] && itemFunMap[dropdownItem]();
  }
  get selectNoSubmit() {
    return (
      this.searchForm.submitStatusList.length > 0 &&
      this.searchForm?.submitStatusList?.[0] !== 2
    );
  }
  assessDo() {
    if (!this.$P.person.judge || this.selectNoSubmit) return;
    ExamList.getCandidateListIds(this.searchForm as any).then(res => {
      this.searchForm.candidateIdList = res.data.candidateIds; //新需求：阅卷页以后是打包带走这些筛选出来的人
      if (res?.data?.candidateIds?.length === 0) {
        this.$message.warning("没有可评估的候选人");
        return;
      }
      const params = JSON.parse(JSON.stringify(this.searchForm));
      if (!params.createdTime.length) {
        params.createdTime = ["1970-01-01 00:00:00", "2999-01-01 00:00:00"];
      }
      sessionStorage.setItem("candidateParams", JSON.stringify(params));
      const cid = Auth.companyId;
      const previewUrl = `/exam/mark?examId=${
        this.searchForm.examId
      }&companyId=${cid}&auditStatus=${
        this.searchForm.auditStatusList.length === 1
          ? this.searchForm.auditStatusList[0]
          : 0
      }`;
      window.open(previewUrl);
      this.searchForm.candidateIdList = [];
    });
  }
  sureDialog = false;
  sureDialogTitle = "";
  sureDialogShowText = "";
  sureDialogCancelText = "";
  sureDialogOkText = "";
  exportAllCandidateListForm = new CandidateListForm();
  dialogOfExport = false;
  exportDo() {
    this.sureDialogTitle = "导出数据";
    this.sureDialogShowText = `${this.total}条候选人作答相关数据，需等待一定时间，是否导出？`;
    this.sureDialogCancelText = "取消";
    this.sureDialogOkText = "确认";
    this.sureDialog = true;
    this.dialogOfExport = true;
  }
  dialogOfExportCasePage = false;
  sureDialogOk() {
    // 导出确认事件
    if (this.dialogOfExport) {
      this.sureDialogCancel();
      this.exportAllCandidateListForm = new CandidateListForm();
      this.exportAllCandidateListForm.candidateIdList = [];
      this.exportAllCandidateListForm.page = 1;
      this.exportAllCandidateListForm.pageSize = this.total;
      track("click_export_candidate", {
        operation_type: "按钮点击",
        operation_name: "导出候选人",
        click_from: "从左侧候选人菜单进入候选人列表页"
      });

      const exportForm = this.exportAllCandidateListForm;
      if (this.exportAllCandidateListForm.auditStatusList.length === 3) {
        exportForm.auditStatusList = [];
      }
      this.loadingList = true;
      ExamList.candidateListExport(this.exportAllCandidateListForm)
        .then(res => {
          if (res.code === 0) {
            if (res.data.isAsync === 1) {
              // 异步导出
              this.loadingList = false;
              // this.isShowDownloadModal = true;
              this.sureDialogTitle = "提示";
              this.sureDialogShowText =
                "导出任务创建成功，请在导出任务页查看进度或下载导出结果";
              this.sureDialogCancelText = "关闭";
              this.sureDialogOkText = "查看";
              this.sureDialog = true;
              this.dialogOfExportCasePage = true;
            } else {
              this.loadingList = false;
              const dataUrl = res.data.ossUrl;
              const a = document.createElement("a");
              a.href = dataUrl;
              a.setAttribute("download", "候选人列表");
              a.click();
            }
          }
        })
        .finally(() => {
          this.loadingList = false;
        });
    }
    // 查看异步任务列表事件
    if (this.dialogOfExportCasePage) {
      this.sureDialogCancel();
      this.$router.push({
        path: "/export/list"
      });
    }
  }
  sureDialogCancel() {
    this.sureDialog = false;
    this.dialogOfExport = false;
    this.dialogOfExportCasePage = false;
  }
}
